/* src/modules/dashboard/components/DataCard/styles.js */

export default theme => ({
  card: {
    padding: theme.spacing.unit * 2,
  },
  title: {
    marginBottom: theme.spacing.unit * 2,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/DataCard/styles.js